import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Header from "./header"
import IconButton from "@material-ui/core/IconButton"
import { makeStyles } from "@material-ui/core/styles"
import "normalize.css"
import NewsLetter from "./NewsLetter"
import Up from "../assets/images/remontada.png"
import Arrow from "../assets/images/remonte.png"

import { Link } from "gatsby"

// import FullScreenDialog from "./FullPageDialog"

const navigation = {
  social: [
    {
      name: "Linkedin",
      href: "https://www.linkedin.com/company/bruno-lafon-selection/",
      icon: props => (
        <svg
          fill="currentColor"
          width="30"
          height="30"
          viewBox="0 0 48 48"
          {...props}
        >
          <path
            fill="#0288D1"
            d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
          ></path>
          <path
            fill="#FFF"
            d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
          ></path>
        </svg>
      ),
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/brunolafonselection/",
      icon: props => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <defs>
            <radialGradient
              id="a"
              gradientUnits="userSpaceOnUse"
              cx={158.429}
              cy={578.088}
              fx={158.429}
              fy={578.088}
              r={65}
              gradientTransform="matrix(0 -.36036 .33526 0 -187.345 82.728)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#fd5",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset={0.1}
                style={{
                  stopColor: "#fd5",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset={0.5}
                style={{
                  stopColor: "#ff543e",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#c837ab",
                  stopOpacity: 1,
                }}
              />
            </radialGradient>
            <radialGradient
              id="b"
              gradientUnits="userSpaceOnUse"
              cx={147.694}
              cy={473.455}
              fx={147.694}
              fy={473.455}
              r={65}
              gradientTransform="matrix(.03163 .15795 -.65124 .1304 299.882 -83.18)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "#3771c8",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset={0.128}
                style={{
                  stopColor: "#3771c8",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "#60f",
                  stopOpacity: 0,
                }}
              />
            </radialGradient>
          </defs>
          <path
            style={{
              stroke: "none",
              fillRule: "nonzero",
              fill: "url(#a)",
            }}
            d="M12.008.184c-4.938 0-6.38.004-6.66.027C4.336.293 3.703.453 3.02.797c-.532.262-.95.566-1.36.992C.91 2.57.457 3.527.29 4.664c-.08.555-.102.668-.106 3.488-.004.942 0 2.18 0 3.844 0 4.93.004 6.371.027 6.652.082.985.238 1.606.566 2.282a4.962 4.962 0 0 0 3.227 2.636c.484.125 1.023.196 1.715.227.293.016 3.277.023 6.261.023 2.985 0 5.973-.003 6.258-.02.801-.034 1.262-.097 1.778-.23a4.95 4.95 0 0 0 3.226-2.644c.32-.66.485-1.305.559-2.238.015-.204.023-3.45.023-6.692s-.008-6.484-.023-6.687c-.074-.95-.238-1.59-.57-2.262a4.63 4.63 0 0 0-1.012-1.387C21.437.91 20.48.453 19.339.29c-.55-.078-.66-.101-3.487-.105Zm0 0"
          />
          <path
            style={{
              stroke: "none",
              fillRule: "nonzero",
              fill: "url(#b)",
            }}
            d="M12.008.184c-4.938 0-6.38.004-6.66.027C4.336.293 3.703.453 3.02.797c-.532.262-.95.566-1.36.992C.91 2.57.457 3.527.29 4.664c-.08.555-.102.668-.106 3.488-.004.942 0 2.18 0 3.844 0 4.93.004 6.371.027 6.652.082.985.238 1.606.566 2.282a4.962 4.962 0 0 0 3.227 2.636c.484.125 1.023.196 1.715.227.293.016 3.277.023 6.261.023 2.985 0 5.973-.003 6.258-.02.801-.034 1.262-.097 1.778-.23a4.95 4.95 0 0 0 3.226-2.644c.32-.66.485-1.305.559-2.238.015-.204.023-3.45.023-6.692s-.008-6.484-.023-6.687c-.074-.95-.238-1.59-.57-2.262a4.63 4.63 0 0 0-1.012-1.387C21.437.91 20.48.453 19.339.29c-.55-.078-.66-.101-3.487-.105Zm0 0"
          />
          <path
            style={{
              stroke: "none",
              fillRule: "nonzero",
              fill: "#fff",
              fillOpacity: 1,
            }}
            d="M12 3.273c-2.371 0-2.668.008-3.598.051-.93.043-1.562.192-2.117.406a4.281 4.281 0 0 0-1.547 1.008A4.3 4.3 0 0 0 3.73 6.281c-.214.559-.363 1.192-.406 2.121-.039.93-.05 1.227-.05 3.598 0 2.371.011 2.668.05 3.598.043.93.192 1.562.406 2.117a4.281 4.281 0 0 0 1.008 1.547 4.3 4.3 0 0 0 1.543 1.008c.559.214 1.192.363 2.121.406.93.043 1.227.05 3.598.05 2.371 0 2.668-.007 3.598-.05.93-.043 1.562-.192 2.117-.406a4.281 4.281 0 0 0 1.547-1.008 4.281 4.281 0 0 0 1.008-1.547c.214-.555.359-1.188.406-2.117.039-.93.05-1.227.05-3.598 0-2.371-.011-2.668-.05-3.598-.047-.93-.192-1.562-.406-2.117a4.281 4.281 0 0 0-1.008-1.547 4.23 4.23 0 0 0-1.547-1.008c-.555-.214-1.192-.363-2.117-.406-.934-.043-1.23-.05-3.602-.05Zm-.781 1.57H12c2.332 0 2.605.012 3.527.052.852.039 1.313.183 1.621.3.407.16.696.348 1.004.653.305.308.493.597.653 1.004.117.308.261.77.3 1.62.04.919.051 1.196.051 3.524 0 2.332-.011 2.606-.05 3.527-.04.852-.184 1.313-.301 1.622-.16.406-.348.695-.653 1a2.674 2.674 0 0 1-1.004.652c-.308.121-.77.262-1.62.3-.923.044-1.196.051-3.528.051-2.328 0-2.605-.007-3.527-.05-.848-.04-1.313-.18-1.618-.301-.41-.156-.699-.344-1.003-.652a2.686 2.686 0 0 1-.657-1c-.117-.31-.261-.77-.3-1.622-.04-.921-.047-1.195-.047-3.527s.007-2.605.047-3.527c.039-.848.183-1.313.3-1.617.16-.41.348-.7.657-1.004a2.67 2.67 0 0 1 1.003-.657c.305-.117.77-.261 1.618-.3.804-.036 1.117-.047 2.746-.047Zm5.441 1.45c-.578 0-1.047.469-1.047 1.047s.469 1.05 1.047 1.05a1.05 1.05 0 0 0 1.047-1.05c0-.578-.469-1.047-1.047-1.047ZM12 7.52a4.48 4.48 0 1 0 0 8.96 4.48 4.48 0 0 0 0-8.96Zm0 1.57A2.912 2.912 0 0 1 14.91 12 2.912 2.912 0 0 1 12 14.91 2.912 2.912 0 0 1 9.09 12 2.912 2.912 0 0 1 12 9.09Zm0 0"
          />
        </svg>
      ),
    },
  ],
}

const Layout = ({ children, relative, path, data }) => {
  const style = {
    Cover: { position: "relative" },
    NoCover: { position: "static" },
  }

  const coverStyles = relative ? style.Cover : style.NoCover

  return (
    <div>
      {/* <FullScreenDialog /> */}
      <Scroll showBelow={600} />
      <div style={coverStyles}>
        <Header relative={relative} />
        <main className="bg-white">{children}</main>

        <FooterStyles className="py-[8px] justify-center w-full shadow-lg">
          <div className="max-w-[1200px] mx-auto">
            <div className="lg:flex lg:justify-between lg:px-48 items-center">
              <NewsLetter />
              <div className="mt-8 lg:mt-0 footer__links">
                <div className="flex justify-center">
                  <div className="mr-16">
                    <h3>wineries</h3>
                    <ul className="mt-2">
                      <li>
                        <Link to="/french-wines/">French wines</Link>
                      </li>
                      <li>
                        <Link to="/italy-wines/">Italian wines</Link>
                      </li>
                      <li>
                        <Link to="/spain-wines/">Spanish wines</Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3>Sitemap</h3>
                    <ul className="mt-2 lg:flex">
                      <div>
                        <li>
                          <Link to="/about-us/">About Us</Link>
                        </li>
                        <li>
                          <Link to="/contact/">Contact Us</Link>
                        </li>
                        <li>
                          <Link to="/news/" className="">
                            News
                          </Link>
                        </li>
                      </div>
                      <div className="lg:ml-4">
                        <li>
                          <Link to="/us-partners/">Partners</Link>
                        </li>
                        <li>
                          <Link to="/privacy" className="">
                            Privacy
                          </Link>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 lg:mt-0 flex flex-col lg:flex-row lg:justify-between lg:px-48 items-center">
              <p className="hellobb" style={{ fontSize: "16px" }}>
                {" "}
                © {new Date().getFullYear()}, brunolafonselection.com, all
                rights reserved.
              </p>
              <div className="mt-6 lg:mt-0 flex items-center space-x-6 md:order-2">
                {navigation.social.map(item => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-white hover:text-gray-300 hover:opacity-80"
                  >
                    <span className="sr-only">{item.name}</span>
                    <item.icon className="" aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </FooterStyles>
      </div>
    </div>
  )
}

const Scroll = ({ showBelow }) => {
  const classes = useStyles()

  const [show, setShow] = useState(showBelow ? false : true)

  const handleScroll = () => {
    if (window.pageYOffset > showBelow) {
      if (!show) setShow(true)
    } else {
      if (show) setShow(false)
    }
  }

  const handleClick = () => {
    window[`scrollTo`]({ top: 0, behavior: `smooth` })
  }

  useEffect(() => {
    if (showBelow) {
      window.addEventListener(`scroll`, handleScroll)
      return () => window.removeEventListener(`scroll`, handleScroll)
    }
  })

  return (
    <div className="upIcon">
      {show && (
        <>
          <IconButton
            onClick={handleClick}
            className={classes.toTop}
            aria-label="to top"
            component="span"
          >
            <img src={Up} alt="osef" className="remontada" />
            <img src={Arrow} alt="up" className="upArrow" />
          </IconButton>
        </>
      )}
    </div>
  )
}

export const FooterStyles = styled.footer`
  justify-content: center;
  margin: 0 auto;
  background-color: var(--secondary);
  color: var(--grey);

  .footer__links {
    border-bottom: 1px solid #e1e1e1;
    padding-bottom: 28px;
  }

  p {
    font-size: 18px;
    color: #363636 !important;
  }

  a {
    font-size: 14px;
    color: #7e7e7e !important;
    margin-bottom: 2rem;
  }

  @media only screen and (min-width: 1024px) {
    .footer__links {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  @media only screen and (max-width: 400px) {
    font-size: 18px;
  }
`

// const StyledLayout = styled.div`
//   background-color: ${({ path }) => (path !== "jeanyves" ? "#fff" : "#000")};
// `

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const useStyles = makeStyles(theme => ({
  toTop: {
    zIndex: 2,
    position: "fixed",
    bottom: "4vh",
    backgroundColor: "#f7f5f5",
    color: "white",
    "&:hover, &.Mui-focusVisible": {
      transition: "0.3s",
      color: "white",
      backgroundColor: "#e3dcdc",
    },
    [theme.breakpoints.up("xs")]: {
      right: "5%",
    },
    [theme.breakpoints.up("lg")]: {
      right: "6.5%",
    },
  },
}))

export default Layout
